import React from "react";
import { Pie } from "react-chartjs-2";


export default function PieChart({ chartData, options }) {
  return (
    <>
      <Pie data={chartData} options={options}/>
    </>
  );
}
